import palette from '../palette';

export default {
  colorDefault: {
    color: palette.common.white,
    backgroundColor: palette.avatar.background,
  },
};
